import s from './NavMainFields.module.scss';

interface NavMainFieldsProps {
  date: string;
  passageFrom: string;
  passageTo: string;
  onChange: (field: 'date' | 'passageFrom' | 'passageTo', value: string) => void;
}

export function NavMainFields({ passageFrom, passageTo, onChange }: NavMainFieldsProps) {
  return (
    <div className={s.root}>
      <div className={s.passageGrid}>
        {/* <div className={`${s.passageCell} ${s.dateCell}`}>
          <label className={s.stackLabel}>Date</label>
          <FormDatePicker
            label=""
            placeholder="Select date"
            value={date}
            onChange={(value) => onChange('date', value)}
            showTimeInput={false}
          />
        </div> */}
        <div className={s.passageCell}>
          <span className={s.inlineLabel}>Passage From</span>
          <input
            type="text"
            value={passageFrom}
            onChange={(e) => onChange('passageFrom', e.target.value)}
            className={s.textInput}
          />
        </div>
        <div className={s.passageCell}>
          <span className={s.inlineLabel}>To</span>
          <input
            type="text"
            value={passageTo}
            onChange={(e) => onChange('passageTo', e.target.value)}
            className={s.textInput}
          />
        </div>
      </div>
    </div>
  );
}
